import Vue from "vue";
import { mapGetters } from "vuex";
import { LoadingSpinner } from "@/components";
import { formatDateTime, stringHelper } from "@/components/mixins";
import { ErrorLogService, GridUtil, PartDetailServices } from "@/services";

export default Vue.extend({
    name: "ComponentsTab",

    components: {
        LoadingSpinner
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters(["getContentItem", "activeAccountId", "McfCostCenterId"])
    },

    props: {
        oemPartCode: {
            type: String,
            default: "",
        },
        partId: {
            type: Number,
            default: "",
        },
    },

    created() {
        this.componentColumns = GridUtil.localizeColumnLabels(this.componentColumns, this.getContentItem);
        this.usageColumns = GridUtil.localizeColumnLabels(this.usageColumns, this.getContentItem);
    },

    data: () => ({
        componentColumns: [
            { key: "ServiceabilityIndicator", label: "Servicability" },
            { key: "OemPartCode", localizationKey: "PartNumber" },
            { key: "PartDescription", localizationKey: "Description" },
            { key: "Quantity", localizationKey: "QtyNeeded" },
            { key: "InDate", localizationKey: "InDate" },
            { key: "OutDate", localizationKey: "OutDate" },
        ],
        usageColumns: [
            { key: "ServiceabilityIndicator", label: "Servicability" },
            { key: "OemPartCode", localizationKey: "PartNumber" },
            { key: "PartDescription", localizationKey: "Description" },
            { key: "SerialRange", localizationKey: "SerialNumberRange" },
        ],
        whereUsed: [],
        components: [],
        loadingWhereUsed: false,
        haveSuccessfullyLoadedWhereUsed: false,
        loadingComponents: false,
        haveSuccessfullyLoadedComponents: false
    }),

    methods: {
        async getWhereUsed() {
            try {
                this.loadingWhereUsed = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partId: this.partId,
                    oemPartCode: this.oemPartCode
                };
                this.whereUsed = await PartDetailServices.getWhereUsed(params);
                this.haveSuccessfullyLoadedWhereUsed = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingWhereUsed = false;
            }
        },
        async getComponents() {
            try {
                this.loadingComponents = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    kitPartId: this.partId,
                    oemPartCode: this.oemPartCode
                };
                this.components = await PartDetailServices.getComponents(params);
                this.haveSuccessfullyLoadedComponents = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingComponents = false;
            }
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedWhereUsed && !this.loadingWhereUsed){
                this.getWhereUsed();
            }
            if(!this.haveSuccessfullyLoadedComponents && !this.loadingComponents){
                this.getComponents();
            }
        }
    },
});
